import { render, staticRenderFns } from "./MasterUser.vue?vue&type=template&id=dab7b950&scoped=true"
import script from "./MasterUser.vue?vue&type=script&lang=js"
export * from "./MasterUser.vue?vue&type=script&lang=js"
import style0 from "./MasterUser.vue?vue&type=style&index=0&id=dab7b950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab7b950",
  null
  
)

export default component.exports